const localStorageKey = {
  DEFAULT_LANG: "default_lang",
  TOKEN: "token",
  EMAIL_VERIFY_SEND_TIME: "EMAIL_VERIFY_SEND_TIME",
  CART: "cart",
  USER_ACCOUNT: "account",
  PROMOTE_CODE: "promote_code",
  GIFT_POINT: "gift_point",
  USER_NAME: "user_name",
  STORE_CODE: "STORE_CODE",
  HAVE_CART: "have_cart",
};

export default localStorageKey;
